const n = ({
  host: t = "google.com",
  isEnterprise: c = !1,
  render: s,
  hl: e,
  badge: r
}) => {
  const a = new URLSearchParams({
    ...e && { hl: e },
    ...r && { badge: r },
    render: s
  });
  return `https://www.${t}/recaptcha/${c ? "enterprise.js" : "api.js"}?${a}`;
};
export {
  n as generateGoogleReCaptchaScriptSrc
};
//# sourceMappingURL=generateGoogleReCaptchaScriptSrc.js.map
